import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-anomaly-detail-modal',
    templateUrl: './anomaly-detail-modal.component.html',
    styleUrls: ['./anomaly-detail-modal.component.scss']
})
export class AnomalyDetailModalComponent implements OnInit {

    anomalyList: any[] = [];
    title: string = '';
    userName: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AnomalyDetailModalComponent>
    ) {
        this.title = data.title;
        this.userName = data.user.name;
        this.anomalyList = data.dates || [];
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }
}
